import { Component, OnInit } from "@angular/core";
// import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import {MatDialog} from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import Swal from "sweetalert2";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: 'app-gcctracks',
  templateUrl: './gcctracks.component.html',
  styleUrls: ['./gcctracks.component.css']
})
export class GcctracksComponent {
  lif: any;
  lift = [];
  knowmore: any;
  richtext: any;
  know: any;
  displayStyles = "block";
  constructor(private http: HttpClient, private router: Router) {}

  // open(content:any) {
  //   this.modalService.open(content);
  // }
  // openDialog(content:any) {
  //   this.dialog.open(content);
  // }
  ngOnInit(): void {
    this.displayStyles = "block";
    this.http
      .get(environment.API_URL + "getGccTracks/")
      // .get("http://localhost:8000/gcc24/getGccTracks/")
      .subscribe((Response) => {
        if (Response) {
        }
        this.lif = Response;
        this.lift = this.lif.gcctracks;
        this.displayStyles = "none";
      });
  }
  _returnHtmlFromRichText(richText: any) {
    if (
      richText === undefined ||
      richText === null ||
      richText.nodeType !== "document"
    ) {
      return "<p>Error</p>";
    }
    return documentToHtmlString(richText);
  }
  convertToPlain(rtf: any) {
    rtf = rtf.replace(/\\par[d]?/g, "");
    return rtf
      .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "")
      .trim();
  }
  htmlToPlaintext(text: any) {
    return text ? String(text).replace(/<[^>]+>/gm, "") : "";
  }
  displayStyle = "none";
  displayStyle2 = "none";
  openPopup2(know: any) {
    this.displayStyle2 = "block";
    this.knowmore = know;
    // this.knowmore = this.htmlToPlaintext(know)
    console.log(this.knowmore);
  }
  closePopup2() {
    this.displayStyle2 = "none";
  }

  register() {
    if (environment.REGISTRATIONS_CLOSED) {
      Swal.fire("Registration has been Closed!");
      return;
    }

    this.router.navigateByUrl("/reg");
  }
}

